// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"user-count-error__wrapperccZ","content":"user-count-error__content2dG","icon":"user-count-error__icon2a2","button":"user-count-error__button1Zn"};